import React, { Component } from "react";
import Scrollbar from 'react-scrollbars-custom';
import "react-widgets/dist/css/react-widgets.css";
const isEmpty = require("is-empty");

class AddUserModal extends Component {

	state = {
		errorNombre: '',
		errorClave: '',
		errorUsoHorario: '',
		errorCalle: '',
		errorNumeroExterior: '',
		errorColonia: '',
		errorCodigoPostal: '',
		errorMunicipio: '',
		errorEstado: '',
		errorLatitude: '',
		errorLongitude: '',
		nombre: '',
		clave: '',
		usoHorario: '',
		calle: '',
		numeroExterior: '',
		numeroInterior: '',
		colonia: '',
		codigoPostal: '',
		municipio: '',
		estado: '',
		latitude: '',
		longitude: ''
	};


	constructor(props) {
		super(props);
		this.onPressEsc = this.onPressEsc.bind(this);
	}

	componentDidUpdate() {
		document.addEventListener('keydown', this.onPressEsc, false);
	}

	onPressEsc(event) {
		if (event.keyCode === 27) {
			this.onPressCancel();
		}
	}

	onChangeNombre(e) {
		this.setState({
			nombre: e.target.value,
		});
	}

	onChangeClave(e) {
		this.setState({
			clave: e.target.value,
		});
	}

	onChangeUsoHorario(e) {
		this.setState({
			usoHorario: e.target.value,
		});
	}

	onChangeCalle(e) {
		this.setState({
			calle: e.target.value,
		});
	}

	onChangeNumeroExterior(e) {
		this.setState({
			numeroExterior: e.target.value,
		});
	}

	onChangeNumeroInterior(e) {
		this.setState({
			numeroInterior: e.target.value,
		});
	}

	onChangeColonia(e) {
		this.setState({
			colonia: e.target.value,
		});
	}

	onChangeCodigoPostal(e) {
		this.setState({
			codigoPostal: e.target.value,
		});
	}

	onChangeMunicipio(e) {
		this.setState({
			municipio: e.target.value,
		});
	}

	onChangeEstado(e) {
		this.setState({
			estado: e.target.value,
		});
	}

	onChangeLatitude(e) {
		this.setState({
			latitude: e.target.value,
		});
	}

	onChangeLongitude(e) {
		this.setState({
			longitude: e.target.value,
		});
	}

	clearErrors() {
		this.setState({
			errorNombre: '',
			errorClave: '',
			errorUsoHorario: '',
			errorCalle: '',
			errorNumeroExterior: '',
			errorColonia: '',
			errorCodigoPostal: '',
			errorMunicipio: '',
			errorEstado: '',
			errorLatitude: '',
			errorLongitude: ''
		});
	}

	clearData() {
		this.farmazonFormRef.reset();
		this.setState({
			errorNombre: '',
			errorClave: '',
			errorUsoHorario: '',
			errorCalle: '',
			errorNumeroExterior: '',
			errorColonia: '',
			errorCodigoPostal: '',
			errorMunicipio: '',
			errorEstado: '',
			errorLatitude: '',
			errorLongitude: '',
			nombre: '',
			clave: '',
			usoHorario: '',
			calle: '',
			numeroExterior: '',
			numeroInterior: '',
			colonia: '',
			codigoPostal: '',
			municipio: '',
			estado: '',
			latitude: '',
			longitude: ''
		});
	}

	async preparateUpdate() {
		this.clearData()
		this.props.handleUpdate(
			this.props.centerData._id,
			this.state.nombre !== '' ? this.state.nombre : (this.props.centerData.nombre !== null ? this.props.centerData.nombre : ''),
			this.state.clave !== '' ? this.state.clave : (this.props.centerData.clave !== null ? this.props.centerData.clave : ''),
			this.state.usoHorario !== '' ? this.state.usoHorario : (this.props.centerData.usoHorario !== null ? this.props.centerData.usoHorario : ''),
			this.state.calle !== '' ? this.state.calle : (this.props.centerData.direccion ? this.props.centerData.direccion.calle : ''),
			this.state.numeroExterior !== '' ? this.state.numeroExterior : (this.props.centerData.direccion ? this.props.centerData.direccion.numeroExterior : ''),
			this.state.numeroInterior !== '' ? this.state.numeroInterior : (this.props.centerData.direccion ? this.props.centerData.direccion.numeroInterior : ''),
			this.state.colonia !== '' ? this.state.colonia : (this.props.centerData.direccion ? this.props.centerData.direccion.colonia : ''),
			this.state.codigoPostal !== '' ? this.state.codigoPostal : (this.props.centerData.direccion ? this.props.centerData.direccion.codigoPostal : ''),
			this.state.municipio !== '' ? this.state.municipio : (this.props.centerData.direccion ? this.props.centerData.direccion.municipio : ''),
			this.state.estado !== '' ? this.state.estado : (this.props.centerData.direccion ? this.props.centerData.direccion.estado : ''),
			this.state.latitude !== '' ? this.state.latitude : (this.props.centerData.latitude !== null ? this.props.centerData.latitude : ''),
			this.state.longitude !== '' ? this.state.longitude : (this.props.centerData.longitude !== null ? this.props.centerData.longitude : '')
		);
	}

	async preparateSubmit() {
		await this.clearErrors()
		if (this.state.nombre == null || isEmpty(this.state.nombre))
			this.setState({ errorNombre: "El nombre del centro es requerido." });
		else
			this.setState({ isValidNombre: true });

		if (this.state.clave == null || isEmpty(this.state.clave))
			this.setState({ errorClave: "La clave es requerida." });
		else
			this.setState({ isValidClave: true });

		if (this.state.usoHorario == null || isEmpty(this.state.usoHorario))
			this.setState({ errorUsoHorario: "El uso horario es requerido." });
		else
			this.setState({ isValidUsoHorario: true });
		if (
			this.state.isValidNombre &&
			this.state.isValidClave &&
			this.state.isValidUsoHorario
		) {
			this.props.handleSubmit(
				this.state.nombre,
				this.state.clave,
				this.state.usoHorario,
				this.state.calle,
				this.state.numeroExterior,
				this.state.numeroInterior,
				this.state.colonia,
				this.state.codigoPostal,
				this.state.municipio,
				this.state.estado,
				this.state.latitude,
				this.state.longitude
			)
			this.clearData()
		}
	}

	onPressCancel() {
		this.farmazonFormRef.reset();
		this.nombreForm.value = '';
		this.setState(
			{
				errorNombre: '',
				errorClave: '',
				errorUsoHorario: '',
				errorCalle: '',
				errorNumeroExterior: '',
				errorColonia: '',
				errorCodigoPostal: '',
				errorMunicipio: '',
				errorEstado: '',
				errorLatitude: '',
				errorLongitude: '',
				nombre: '',
				clave: '',
				usoHorario: '',
				calle: '',
				numeroExterior: '',
				numeroInterior: '',
				colonia: '',
				codigoPostal: '',
				municipio: '',
				estado: '',
				latitude: '',
				longitude: ''
			},
			() => {
				this.props.handleCancel();
			}
		);
	}

	onDelete() {
		this.props.onDelete(this.props.centerData._id);
	}

	render() {
		var title = "CAPTURA LOS SIGUIENTES DATOS";
		if (this.props.type === "UPDATE") {
			title = "ACTUALIZA LOS DATOS";
		}


		return (
			<div
				className={
					this.props.isVisible ? "modal display-block" : "modal display-none"
				}
			>
				<div className="modal-center-main">
					<Scrollbar style={{ width: '80%', height: '100%' }}>
						<div className="auth-group">
							<center>{title}</center>
							<div className="auth-label"></div>
							<div className="auth-label"></div>
							<form
								ref={(el) => {
									this.farmazonFormRef = el;
								}}
							>

								<table align="center" width="100%" cellPadding="0" cellSpacing="0" border="0">
									<tbody>
										<tr>
											<td><div className="auth-label">Nombre del centro<span className="required">*</span></div></td>
											<td><div className="auth-label">Clave<span className="required">*</span></div></td>
											<td><div className="auth-label">Uso horario<span className="required">*</span></div></td>
										</tr>
										<tr>
											<td>
												<input
													id="nombreForm"
													ref={(el) => {
														this.nombreForm = el;
													}}
													onChange={this.onChangeNombre.bind(this)}
													value={
														this.state.nombre
													}
													error={this.state.errorNombre}
													type="title"
													placeholder={this.props.centerData ? this.props.centerData.nombre :
														"Ej.: Centro Pachuca"
													}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorNombre}
												</div>
											</td>

											<td>

												<input
													id="claveForm"
													ref={(el) => {
														this.claveForm = el;
													}}
													onChange={this.onChangeClave.bind(this)}
													value={
														this.state.clave
													}
													error={this.state.errorClave}
													type="title"
													placeholder={this.props.centerData ? this.props.centerData.clave : "Ej.: F015"}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorClave}
												</div>
											</td>

											<td>
												<input
													id="usoHorarioForm"
													ref={(el) => {
														this.usoHorarioForm = el;
													}}
													onChange={this.onChangeUsoHorario.bind(this)}
													value={
														this.state.usoHorario
													}
													error={this.state.errorUsoHorario}
													type="title"
													placeholder={this.props.centerData ? this.props.centerData.usoHorario : "Ej.: 5"}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorUsoHorario}
												</div>
											</td>
										</tr>
									</tbody>

								</table>
								<p>Dirección</p>
								<table align="center" width="100%" cellPadding="0" cellSpacing="0" border="0">
									<tbody>
										<tr>
											<td><div className="auth-label">Calle<span className="required">*</span></div></td>
											<td><div className="auth-label">Número exterior<span className="required">*</span></div></td>
											<td><div className="auth-label">Número interior</div></td>
										</tr>
										<tr>
											<td>
												<input
													id="calleForm"
													ref={(el) => {
														this.calleForm = el;
													}}
													onChange={this.onChangeCalle.bind(this)}
													value={
														this.state.calle
													}
													error={this.state.errorCalle}
													type="title"
													placeholder={
														this.props.centerData ?
															(this.props.centerData.direccion ? this.props.centerData.direccion.calle : "Ej.: Calle los lirios") :
															"Ej.: Calle los lirios"
													}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorCalle}
												</div>
											</td>
											<td>
												<input
													id="numeroExteriorForm"
													ref={(el) => {
														this.numeroExteriorForm = el;
													}}
													onChange={this.onChangeNumeroExterior.bind(this)}
													value={
														this.state.numeroExterior
													}
													error={this.state.errorNumeroExterior}
													type="title"
													placeholder={
														this.props.centerData ? (this.props.centerData.direccion ? this.props.centerData.direccion.numeroExterior : "Ej.: #153") :
															"Ej.: #153"
													}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorNumeroExterior}
												</div>
											</td>
											<td>
												<input
													id="numeroInteriorForm"
													ref={(el) => {
														this.numeroInteriorForm = el;
													}}
													onChange={this.onChangeNumeroInterior.bind(this)}
													value={
														this.state.numeroInterior
													}
													type="title"
													placeholder={
														this.props.centerData ?
															(this.props.centerData.direccion ? this.props.centerData.direccion.numeroInterior : "Ej.: #15") :
															"Ej.: #15"
													}
													className="local-store-input"
												/>
											</td>
										</tr>
										<tr>
											<td><div className="auth-label">Colonia<span className="required">*</span></div></td>
											<td><div className="auth-label">Código Postal<span className="required">*</span></div></td>
											<td><div className="auth-label">Municipio</div></td>
										</tr>
										<tr>
											<td>
												<input
													id="coloniaForm"
													ref={(el) => {
														this.coloniaForm = el;
													}}
													onChange={this.onChangeColonia.bind(this)}
													value={
														this.state.colonia
													}
													error={this.state.errorColonia}
													type="title"
													placeholder={
														this.props.centerData ?
															(this.props.centerData.direccion ? this.props.centerData.direccion.colonia : "Ej.: San Isidro") :
															"Ej.: San Isidro"
													}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorColonia}
												</div>
											</td>
											<td>
												<input
													id="codigoPostalForm"
													ref={(el) => {
														this.codigoPostalForm = el;
													}}
													onChange={this.onChangeCodigoPostal.bind(this)}
													value={
														this.state.codigoPostal
													}
													error={this.state.errorCodigoPostal}
													type="title"
													placeholder={
														this.props.centerData ?
															(this.props.centerData.direccion ? this.props.centerData.direccion.codigoPostal : "Ej.: 42123") :
															"Ej.: 42123"
													}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorCodigoPostal}
												</div>
											</td>
											<td>
												<input
													id="municipioForm"
													ref={(el) => {
														this.municipioForm = el;
													}}
													onChange={this.onChangeMunicipio.bind(this)}
													value={
														this.state.municipio
													}
													error={this.state.errorMunicipio}
													type="title"
													placeholder={
														this.props.centerData ?
															(this.props.centerData.direccion ? this.props.centerData.direccion.municipio : "Ej.: Pachuca") :
															"Ej.: Pachuca"
													}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorMunicipio}
												</div>
											</td>
										</tr>
										<tr>
											<td><div className="auth-label">Estado<span className="required">*</span></div></td>
											<td><div className="auth-label">Latitud del centro<span className="required">*</span></div></td>
											<td><div className="auth-label">Longitud del centro</div></td>
										</tr>
										<tr>
											<td>
												<input
													id="estadoForm"
													ref={(el) => {
														this.estadoForm = el;
													}}
													onChange={this.onChangeEstado.bind(this)}
													value={
														this.state.estado
													}
													error={this.state.errorEstado}
													type="title"
													placeholder={
														this.props.centerData ?
															(this.props.centerData.direccion ? this.props.centerData.direccion.estado : "Ej.: Hidalgo") :
															"Ej.: Hidalgo"
													}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorEstado}
												</div>
											</td>
											<td>
												<input
													id="latForm"
													ref={(el) => {
														this.latForm = el;
													}}
													onChange={this.onChangeLatitude.bind(this)}
													value={
														this.state.latitude
													}
													error={this.state.errorLatitude}
													type="title"
													placeholder={
														this.props.centerData
															? (this.props.centerData.latitude ? this.props.centerData.latitude : "Ej.: 19.4792818")
															: "Ej.: 19.4792818"
													}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorLatitude}
												</div>
											</td>
											<td>
												<input
													id="longForm"
													ref={(el) => {
														this.longForm = el;
													}}
													onChange={this.onChangeLongitude.bind(this)}
													value={
														this.state.longitude
													}
													error={this.state.errorLongitude}
													type="title"
													placeholder={
														this.props.centerData ?
															(this.props.centerData.longitude ? this.props.centerData.longitude : "Ej.: -99.0881017") :
															"Ej.: -99.0881017"
													}
													className="local-store-input"
												/>
												<div className="auth-error">
													{this.state.errorLongitude}
												</div>
											</td>
										</tr>
									</tbody>
								</table>

							</form>
							<br></br>
							<div className="modal-activity-section">
								{this.props.type === "UPDATE" && (
									<button className="modal-buttonOK" onClick={this.preparateUpdate.bind(this)}>
										ACTUALIZAR
									</button>
								)}
								{this.props.type !== "UPDATE" && (
									<button className="modal-buttonOK" onClick={this.preparateSubmit.bind(this)}>
										GUARDAR
									</button>
								)}
								{
									<button
										className="modal-buttonNo"
										onClick={this.onPressCancel.bind(this)}
									>
										CERRAR
									</button>
								}
							</div>
						</div>
					</Scrollbar>
				</div>
			</div>
		);
	}
}

export default AddUserModal;
